export const SearchTranslations = {
  'eng': {
    beginSearch: 'Search...'
  },
  'hrv': {
    beginSearch: 'Pretraži...'
  }
};
